export default {
  position: 'bottom-center',
  toastOptions: {
    duration: 5000,
  },
  containerStyle: { bottom: '8rem' },
};
